import axios from './axios';

/**
 * @api post /emergency/conference Start call with user.
 *
 * @param {string} userId
 *
 * @return {Promise}
 */
export const startCallSession = (userId, isPrivateCall) =>
  axios.post('/emergency/conference', {
    userIds: [userId],
    personalPhone: isPrivateCall,
  });

/**
 * @api delete /emergency/conference Stop current call.
 *
 *
 * @return {Promise}
 */
export const stopCallSession = () => axios.delete('/emergency/conference');
